import { render, staticRenderFns } from "./ddbes_app.vue?vue&type=template&id=4d3b22e8&"
import script from "./ddbes_app.vue?vue&type=script&lang=js&"
export * from "./ddbes_app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports